import React from 'react';
import styled from 'styled-components';
import { breakpoints } from 'components/carousel-slider/helpers';
import { dimensions } from 'src/components/carousels';
import Skeleton from './loading-skeleton';

const productCardLoadingSkeleton = (props) => {
  const { className } = props;
  const imgSize = className === `homepage` ? 175 : 160;

  return (
    <SkeletonWrapper dimensions={dimensions}>
      <Skeleton width={imgSize} height={imgSize} />
      <SkeletonContentContainer className={className}>
        <Skeleton width={44} height={8} />
        <Skeleton width={137} height={10} />
        <Skeleton width={94} height={8} />
        <Inline>
          <Skeleton width={59} height={8} mr={10} />
          <Skeleton width={59} height={8} />
        </Inline>
      </SkeletonContentContainer>
    </SkeletonWrapper>
  );
};

export default productCardLoadingSkeleton;

const SkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 288px;
  min-width: ${(props) => props.dimensions.desktop}px;
  @media (min-width: ${breakpoints.mobile}px) {
    padding: 15px;
  }
  @media (max-width: ${breakpoints.mobile}px) {
    max-width: ${(props) => props.dimensions.mobile}px;
  }
`;

const SkeletonContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 160px;
  height: 104px;
  margin-top: 30px;

  &.homepage {
    width: 175px;
  }
`;

const Inline = styled.div`
  display: flex;
`;
